import { REQUEST_TYPE_CONFIG } from '../../../core/types';
import { onlyDigits } from '../utils/masks';
import { SubmissionResult, SubmitRequestPayload } from '../types/submission';
import { createTicket } from './createTicket';
import { getCaptchaToken } from './recaptcha';

export async function submitRequest(payload: SubmitRequestPayload): Promise<SubmissionResult> {
  if (!payload.storeType) {
    throw new Error('Não foi possível identificar o tipo de loja para o envio.');
  }

  // Falha fechada (RN03): sem token não há envio, e o fluxo cai no ErrorStep com o 0800.
  const captchaToken = await getCaptchaToken();

  const ticket = await createTicket({
    name: payload.personalData.name,
    phone: onlyDigits(payload.personalData.phone),
    email: payload.personalData.email,
    cpfCnpj: onlyDigits(payload.personalData.cpf),
    description: payload.description,
    category: REQUEST_TYPE_CONFIG[payload.type].value,
    serviceFirstLevelId: Number(payload.themeId),
    storeTypeId: payload.storeType,
    branchId: payload.branch ?? '',
    attachments: payload.files,
    captchaToken,
  });

  return {
    ticketId: String(ticket.id),
    confirmationEmail: payload.personalData.email || undefined,
  };
}
